<template>
  <div id="app" class="section">

    <div class="modal has-text-centered" :class="{'is-active' : hasNotPassword}">
      <div class="modal-background" id="pilot-modal-background"></div>
      <div class="modal-content" id="pilot-modal">
        <div class="card" id="pilot-card">

          <label class="label">Passord</label>
          <div class="field has-addons" id="field-centered">
            <p class="control">
              <input class="input" type="password" placeholder="Passord" v-model="enteredPassword">
            </p>
            <p class="control">
              <a class="button is-primary" @click="removePilotModal(enteredPassword)">
                Gå til Combine
              </a>
            </p>
          </div>
          <!--
          <h4 class="title">Velkommen til Combine!</h4>
          <p>Combine er for tiden i pilotfase, før vi lanserer det for fullt i løpet av høsten 2018. Er du en del av pilotprosjektet? Legg inn passordet ditt under for å logge inn.
            <br><br><strong>Synes du Combine høres kult ut?</strong> <br> Registrer eposten din under så skal vi sørge for at du blir den første vi forteller når Combine lanserers!</p>
            <br>

            <div class="notification wrong-passord" id="wrong-password-pilot" :class="{'is-hidden' : correctPassword}">
              Feil passord!
              <p>Hvis du er en del av pilotprosjektet men har glemt passordet kan du sende mail til info@combine.no eller ringe 40524947 når som helst!</p>
            </div>

            <label class="label">Passord</label>
            <div class="field has-addons" id="field-centered">
              <p class="control">
                <input class="input" type="password" placeholder="Passord" v-model="enteredPassword">
              </p>
              <p class="control">
                <a class="button is-primary" @click="removePilotModal(enteredPassword)">
                  Gå til Combine
                </a>
              </p>
            </div>
            <br>
            <label class="label">Meld meg på nyhetsbrev</label>
            <div class="field has-addons" id="field-centered">
              <p class="control">
                <input class="input" type="text" placeholder="Epostadresse" v-model="email">
              </p>
              <p class="control">
                <a class="button is-primary" @click="registerEmailonMailinglist()">
                  Meld meg på
                </a>
              </p>
            </div>
-->
          </div>
        </div>
      </div>


      <nav-main></nav-main>
      <router-view></router-view>

    </div>
  </template>

  <script>
  import Header from './components/Header.vue';
  import Firebase from 'firebase';

  export default {
    data() {
      return {
        enteredPassword: '',
        pilotPassword: 'combineit',
        hasNotPassword: false,
        correctPassword: true,

        email: '',
      }
    },
    components: {
      navMain: Header
    },
    methods: {
      setUser: function() {
        this.$store.dispatch('setUser');
      },
      removePilotModal: function(password) {
        if (password === this.pilotPassword) {
          this.hasNotPassword  = false
        } else {this.correctPassword = false}
      },
      registerEmailonMailinglist: function() {
        var mailRef = Firebase.database().ref('mailinglist/'+this.email);

      }
    },
    created() {
      // when the app is created run the set user method
      // this uses Vuex to check if a user is signed in
      // check out mutations in the store.js file
      this.setUser();
    }
  };
</script>

<style lang="scss">

#pilot-modal-background{
  background-color: black;
  opacity: 0.94;
}

#app {
  padding: 0px;
}

#pilot-modal{
  border-radius: 0px;
}
#pilot-card{
  padding: 20px;
}
#field-centered{
  margin: auto;
  padding-left: 120px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue